import Layout from '@/layout/layout'

const billManagement = {
  path: '/billManagement',
  component: Layout,
  redirect: 'noRedirect',
  name: '账单管理',
  children: [
    {
      path: 'collectTatement',
      component: () => import('@/views/billManagement/collectTatement/index'),
      name: '回收交易账单',
      meta: { title: '回收交易账单', noCache: true }
    },
    {
        path: 'receiptTimesbill',
        component: () => import('@/views/billManagement/receiptTimesbill/index'),
        name: '收货次数账单',
        meta: { title: '收货次数账单', noCache: true }
      },
  ]
}

export default billManagement